<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">随手拍审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查对象">
              <el-input v-model="formInline.checker_name" clearable placeholder="请输入"></el-input>
            </el-form-item>
        <el-form-item label="隐患等级">
          <el-select v-model="formInline.hazard_level" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.yhlevel" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查时间" >
              <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" clearable v-model="formInline.check_date" ></el-date-picker>
         </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="target_name" fixed label="检查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="check_date" label="检查时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_status_text" label="审批状态" width="100px">
        </custom-table-column>
        <custom-table-column prop="reject_reason" label="审批意见" width="160px">
        </custom-table-column>
        <custom-table-column prop="hazard_level_text"  label="隐患等级" width="100px">
        </custom-table-column>
        <custom-table-column prop="deadline" label="整改期限" width="180px">
        </custom-table-column>
        <custom-table-column prop="description"  label="隐患描述" min-width="220px">
        </custom-table-column>
        <custom-table-column label="隐患图片" min-width="240px">
            <template slot-scope="scope" v-if="scope.row.images">
                <el-image v-for="(img, index) in scope.row.images" :key="index"
                    style="width: 50px; height: 50px" :src="img" :preview-src-list="scope.row.images">
                </el-image>
            </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="scope.row.status == 1">
            <el-button @click="handleOper(scope.row, 2, '通过')" type="text" size="small">通过</el-button>
            <el-button @click="handleOper(scope.row, 3, '否决')" type="text" size="small">否决</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="审批意见" prop="reject_reason" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.reject_reason"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        status: '',
      },
      ruleForm: {
        id: '',
        status: '',
        reject_reason: ''
      }
    };
  },
  components: {},
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3?[{ required: true, message: '请输入', trigger: 'blur' }]:[];
    },
  },
  created() {
    this.$store.dispatch('getTarinMent');
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleOper(row, status,str) {
      this.ruleForm.id = row.id
      this.ruleForm.status = status
      this.centerDialogVisible = true
      this.title = `${str}${row.target_name}的随手拍申请`
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/quick-photo/approve`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/quick-photo/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
